import Signin from "@/components/Signin/Signin";
import { Box } from "@mui/material";

export default function SignInPage() {

  return (
    
    <Box>
      <Signin />
    </Box>
  );
}
